export class AudioStreamEventTarget extends EventTarget {
  addEventListener<K extends keyof AudioStreamEventMap>(
    type: K,
    listenerObject: ListenerObject<AudioStreamEventMap[K], this>,
    options?: boolean | AddEventListenerOptions | undefined
  ): void {
    return super.addEventListener(type, listenerObject, options)
  }

  removeEventListener<K extends keyof AudioStreamEventMap>(
    type: K,
    callback: ListenerObject<AudioStreamEventMap[K], this>,
    options?: boolean | EventListenerOptions | undefined
  ): void {
    return super.removeEventListener(type, callback, options)
  }

  dispatchEvent(event: AudioStreamEvent): boolean {
    return super.dispatchEvent(event)
  }
}

export class AudioStreamEvent extends Event {
  constructor(
    type: keyof AudioStreamEventMap,
    eventInit?: EventInit | undefined
  ) {
    super(type, eventInit)
  }
}

export class AudioStreamBlobEvent extends BlobEvent {
  constructor(type: keyof AudioStreamEventMap, eventInit: BlobEventInit) {
    super(type, eventInit)
  }
}

interface AudioStreamEventMap {
  start: AudioStreamEvent
  stop: AudioStreamEvent
  pause: AudioStreamEvent
  cancel: AudioStreamEvent
  resume: AudioStreamEvent
  dataavailable: AudioStreamBlobEvent
}

interface ListenerObject<E extends Event, T extends EventTarget> {
  handleEvent: (event: E & { target: T }) => void
}
